import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var MapIcon = function MapIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e, _f;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    strokeColor = _props.strokeColor,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.312 17.301",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("g", {
    fill: fillColor,
    stroke: (_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : strokeColor,
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-linejoin": "".concat((_e = attrs["stroke-linejoin"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-width": "".concat((_f = attrs["stroke-width"]) !== null && _f !== void 0 ? _f : "1"),
    "transform": "translate(.102 .151)"
  }, [h("path", {
    d: "M6.874 12.7a1.771 1.771 0 0 0 2.482-.02c.883-.878 \n                1.766-1.755 2.633-2.647a5.463 5.463 0 0 0 1.523-5.01A5.56 \n                5.56 0 0 0 7.981.5a4.506 4.506 0 0 0-.715.048 5.605 5.605 \n                0 0 0-4.789 5.944A5.334 5.334 0 0 0 4 9.926Z"
  }), h("circle", {
    cx: "2.244",
    cy: "2.244",
    r: "2.244",
    transform: "translate(5.837 3.635)"
  }), h("path", {
    d: "M13.932 11.893a1 1 0 0 1 .917.6l.525 1.209a2 2 0 0 1-1.835 2.8H2.569A2 2 0 0 1 .734 13.7l.525-1.209a1 1 0 0 1 .917-.6"
  })])]);
};